// npm package imports
import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';

// local package imports
import ErrorIcon from 'packages/smart-home-support/components/ErrorIcon';
import BREAK_POINTS from '../../../styling/media-queries';
import { mobileBreakPointWidth } from '../../../styling/styles';

// Declare interfaces for styled elements such that props can be typed
export const img: StyledFunction<any & React.HTMLProps<HTMLImageElement>> = styled.img;

export const input: StyledFunction<any & React.HTMLProps<HTMLInputElement>> = styled.input;

export const div: StyledFunction<any & React.HTMLProps<HTMLDivElement>> = styled.div;

export const select: StyledFunction<any & React.HTMLProps<HTMLSelectElement>> = styled.select;

export const button: StyledFunction<any & React.HTMLProps<HTMLButtonElement>> = styled.button;

// Shared styled components
export const EnrollmentContentContainer = div`
  display: flex;
  align-items: start;
  flex-direction: column;
  ${mobileBreakPointWidth}
  width: 100%;
  margin: 25px;
  margin-bottom: 0px;

  @media ${BREAK_POINTS.desktop} {
    max-width: ${(props) => (props.isReviewPage === true ? '500' : '400')}px;
  }
`;

export const Select = select`
  background: white;
  border-radius: 0.3em;
  border: ${(props: any) => (props.error ? `0.6px solid ${props.theme.colors.error}` : '0.6px solid #C5C5C5')};
  outline: none;
  height: 56.2px
  padding: 0em 1em;
  padding-right: inherit;
  color: rgb(111,111,111);
  font-size: 16px;

  &:disabled {
    background-color: #f9f9f9;
  }
  &:focus {
    border-color: ${(props) => props.theme.colors.primaryAccent}
  }
`;

export const EnrollmentForm = styled.form`
  width: 100%;
  margin-bottom: 1em;
`;

export const FormRow = div`
  display: flex;
  flex-direction: column;

  @media ${BREAK_POINTS.desktop} {
    ${(props) => (props.alignDesktopItemsCenter === true ? 'align-items: center;' : '')}
  }
`;

export const PaddedFormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${BREAK_POINTS.desktop} {
    width: initial;
  }
`;

export const FormLabel = styled.label`
  color: #1b1b1b;
  font-size: 15px;
  margin-bottom: 0.25em;
  font-weight: 600;

  @media ${BREAK_POINTS.desktop} {
    font-size: 18px;
  }
`;

const ErrorContainer = styled.div<{ top?: number }>`
  height: 30px;
  position: relative;
  top: ${(props) => `${props.top !== undefined ? props.top : 14}px`};
  display: flex;
  align-items: center;
`;

export const ErrorIconContainer = styled.div`
  height: 0px;
  display: flex;
  justify-content: flex-end;
  padding-right: 17px;
`;

export const FieldErrorMessage = styled.div`
  height: 20px;
  color: ${(props) => props.theme.colors.error};
  font-size: 12px;
  font-weight: 500;
  margin-top: 5px;
`;

export const PageErrorMessage = styled.div`
  height: 40px;
  color: ${(props) => props.theme.colors.error};
  font-size: 18px;
  font-weight: 500;
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const LinkButton = div`
  cursor: pointer;
  color: ${(props) => props.theme.colors.primaryAccent};
  border-bottom: 1.5px solid ${(props) => props.theme.colors.primaryAccent};
  &:hover {
    opacity: 0.8;
  }
`;

const DecorContainer = styled.div`
  height: 0px;
  display: flex;
  justify-content: flex-end;
`;

const DecorText = styled.div`
  color: #1b1b1b;
  font-weight: 300;
  position: relative;
  top: -20px;
  font-size: 12px;
`;

export const Error: React.FC<{ top?: number; className?: string }> = (props) => (
  <ErrorContainer top={props.top} className={props.className}>
    <ErrorIcon />
  </ErrorContainer>
);

export const Decor: React.FC<{ label: string }> = (props) => (
  <DecorContainer>
    <DecorText>{props.label}</DecorText>
  </DecorContainer>
);

export const Container = styled.div`
  @media ${BREAK_POINTS.mobile} {
    padding: 20px;
  }

  @media ${BREAK_POINTS.tablet} {
    padding: 50px;
  }

  @media ${BREAK_POINTS.desktop} {
    margin: auto;
    padding: 50px;
    max-width: 1080px;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/signup/components/Common.tsx